import { OrderKeys } from './data'

export const getOrderModuleKey = (key: string) => `${OrderKeys.orderModule}.${key}`
export const getOrderPageKey = (key: string) => `${OrderKeys.orderPage}.${key}`
export const getCreateOrderPageKey = (key: string) => `${OrderKeys.createOrderPage}.${key}`
export const getActivateOrderPageKey = (key: string) => `${OrderKeys.activateOrderPage}.${key}`
export const getOrderItemPageKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`
export const getOrderFilesStepKey = (key: string) => `${OrderKeys.filesStep}.${key}`
export const getOrderWorkConditionsStepKey = (key: string) => `${OrderKeys.workConditionsStep}.${key}`
export const getOrderRequirementsStepKey = (key: string) => `${OrderKeys.requirementsStep}.${key}`

export const parseTariffDescription = (tariffDescription: string): string[] => {
  let tariffDescriptionArray: string[]

  try {
    const parsed = JSON.parse(tariffDescription)
    tariffDescriptionArray = Array.isArray(parsed) ? parsed : []
  } catch (error) {
    tariffDescriptionArray = []
  }

  return tariffDescriptionArray
}
